import { render, staticRenderFns } from "./FlightRow.vue?vue&type=template&id=4323aa5a"
import script from "./FlightRow.vue?vue&type=script&lang=js"
export * from "./FlightRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports